'use client';
import Image, { type ImageProps } from 'next/image';

import { ComponentProps, type SyntheticEvent, useEffect, useState } from 'react';
import { cn } from '../utils/cn';

export function BlurImageWithEffect(props: ImageProps) {
	const [loading, setLoading] = useState(true);
	const [src, setSrc] = useState(props.src);
	useEffect(() => setSrc(props.src), [props.src]); // update the `src` value when the `prop.src` value changes

	const handleLoad = (e: SyntheticEvent<HTMLImageElement, Event>) => {
		setLoading(false);
		const target = e.target as HTMLImageElement;
		if (target.naturalWidth <= 16 && target.naturalHeight <= 16) {
			setSrc(`https://avatar.vercel.sh/${encodeURIComponent(props.alt)}`);
		}
	};

	return (
		<Image
			{...props}
			src={src}
			alt={props.alt}
			className={cn(loading ? 'blur-[2px]' : 'blur-0', props.className)}
			onLoad={handleLoad}
			onError={() => {
				setSrc(`https://avatar.vercel.sh/${encodeURIComponent(props.alt)}`); // if the image fails to load, use the default avatar
			}}
			unoptimized
		/>
	);
}

export type BlurImageProps = {
										imageClassName?: string
										lazy?: boolean
									} & ComponentProps<typeof Image>

export const BlurImage = (props: BlurImageProps) => {
	const { alt, src, className, imageClassName, lazy = true, ...rest } = props
	const [isLoading, setIsLoading] = useState(true)

	return (
		<div className={cn('overflow-hidden', isLoading && 'animate-pulse', className)}>
			<Image
				className={cn(isLoading && 'scale-[1.02] blur-xl grayscale', imageClassName)}
				style={{
					transition: 'filter 700ms ease, scale 150ms ease'
				}}
				src={src}
				alt={alt}
				loading={lazy ? 'lazy' : undefined}
				priority={!lazy}
				quality={100}
				onLoad={() => setIsLoading(false)}
				{...rest}
			/>
		</div>
	)
}